import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import VueI18n from "vue-i18n";
import { getLang } from "./common/utils";

Vue.use(VueI18n);

//语言
let lang = getLang();
if (lang !== "zh-CN" && lang !== "en-US") {
  lang = "en-US";
}
const i18n = new VueI18n({
  locale: lang, // 语言标识, 通过切换locale的值来实现语言切换,this.$i18n.locale
  messages: {
    "zh-CN": require("./lang/zh"), // 中文语言包
    "en-US": require("./lang/en"), // 英文语言包
  },
});

  //路由前置守卫
  router.beforeEach((to, from, next) => {
    if (to.path === "/" || to.path === "/DOC") {
      router.push({ path: "/DOC/Mining Platform Developer Portal" });
      return null;
    }
     if (to.path === "/API" || to.path === "/API/") {
       router.push({ path: "/API/V2.7.0(current)" });
     }
    if(to.path === "/HELP" || to.path === "/HELP/") {
      router.push({ path: "/HELP/FT%20Cloud%20V3.14.3%20Update%20Notes"})
    }
    next();
  });



Vue.use(ElementUI);

Vue.config.productionTip = false;

new Vue({
  router,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
